import * as React from 'react';
import {useRef, useState} from 'react';
import classnames from 'classnames';

import styles from './styles.scss';

type Props = {
    label:string;
    children:any;
    contentTitle?:string;
    dropdownClassName?:string;
    type?:'light';
};

export const Dropdown = (props:Props) => {
    const {label, contentTitle = label, children, dropdownClassName, type = ''} = props;

    const [opened, setOpened] = useState(false);

    const dropdownContentWrapperRef = useRef(null);

    const openDropdown = () => {
        setOpened(true);
        document.addEventListener('click', handleClickOutside, false);
        document.addEventListener('keydown', handleEscPress, false);
    };

    const closeDropdown = () => {
        document.removeEventListener('click', handleClickOutside, false);
        setOpened(false);
    };

    const handleClickOutside = event => {
        if (dropdownContentWrapperRef.current && !dropdownContentWrapperRef.current.contains(event.target)) {
            closeDropdown();
        }
    };

    const handleEscPress = event => {
        if(event.keyCode === 27) {
            closeDropdown();
        }
    };
    
    return (
        <div className={classnames(styles.dropdownWrapper, opened && styles.dropdownWrapperOpened, dropdownClassName, styles[type])}>
            <div className={styles.dropdownLabelContainer} onClick={openDropdown} ref={dropdownContentWrapperRef}>
                <div className={styles.dropdownLabel}>{label}</div>
                <div className={styles.dropdownArrowContainer}>
                    <img src={require('_assets/img/modules/dropdownArrow.svg')} className={styles.dropdownArrow} alt=''/>
                </div>
            </div>

            <div className={styles.dropdownContentWrapper}>
                <div className={styles.dropdownContent}>
                    <div className={styles.dropdownLabelContainer}>
                        <div className={styles.dropdownLabel}>{contentTitle}</div>
                        <div className={styles.dropdownArrowContainer}>
                            <img src={require('_assets/img/modules/dropdownArrow.svg')} className={styles.dropdownArrowOpened} alt=''/>
                        </div>
                    </div>
                    <div className={styles.dropdownInnerContent}>{children}</div>
                </div>
            </div>
        </div>
    );
};